var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lb"},[_c('div',{ref:"Tmain2",staticClass:"tmain2",style:({ width: '440px', height: '240px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }